export enum NewChaseGapActiveScreen {
    Project = 0,
    Member = 1,
    Address = 2,
    Provider = 3,
    Gap = 4,
    Review = 5,
    Confirmation = 6,
  }
